/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkCupStrawIcon16Light } from './FoodDrinkCupStrawIcon16Light';
import { FoodDrinkCupStrawIcon16Regular } from './FoodDrinkCupStrawIcon16Regular';
import { FoodDrinkCupStrawIcon16Solid } from './FoodDrinkCupStrawIcon16Solid';
import { FoodDrinkCupStrawIcon20Light } from './FoodDrinkCupStrawIcon20Light';
import { FoodDrinkCupStrawIcon20Regular } from './FoodDrinkCupStrawIcon20Regular';
import { FoodDrinkCupStrawIcon20Solid } from './FoodDrinkCupStrawIcon20Solid';
import { FoodDrinkCupStrawIcon24Regular } from './FoodDrinkCupStrawIcon24Regular';
import { FoodDrinkCupStrawIcon24Solid } from './FoodDrinkCupStrawIcon24Solid';
import { FoodDrinkCupStrawIcon32Regular } from './FoodDrinkCupStrawIcon32Regular';
import { FoodDrinkCupStrawIcon64Regular } from './FoodDrinkCupStrawIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkCupStrawIcon16Light,
        regular: FoodDrinkCupStrawIcon16Regular,
        solid: FoodDrinkCupStrawIcon16Solid,
    },
    20: {
        light: FoodDrinkCupStrawIcon20Light,
        regular: FoodDrinkCupStrawIcon20Regular,
        solid: FoodDrinkCupStrawIcon20Solid,
    },
    24: {
        regular: FoodDrinkCupStrawIcon24Regular,
        solid: FoodDrinkCupStrawIcon24Solid,
    },
    32: {
        regular: FoodDrinkCupStrawIcon32Regular,
    },
    64: {
        regular: FoodDrinkCupStrawIcon64Regular,
    },
};
export var FoodDrinkCupStrawIcon = forwardRef('FoodDrinkCupStrawIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
